import Iconmoon from '@deprecated-ui/common/Iconmoon';
import color from '@deprecated-ui/_style/color';
import React from 'react';
import { CloseIconWrapper, ImageItem, ModalImage } from './styled';
import SliderButton from './SliderButton';

interface ModalImageSliderProps {
  images: Array<string>;
  visible: boolean;
  onClose: () => void;
  active: number;
  setActive: (val: number) => void;
}

function ModalImageSlider({
  images,
  visible,
  onClose,
  active,
  setActive,
}: ModalImageSliderProps) {
  if (images.length === 0) {
    return null;
  }

  const hasNextButton = active < images.length - 1;
  const hasPrevButton = active > 0;

  const handleNext = () => {
    setActive(active + 1);
  };

  const handlePrev = () => {
    setActive(active - 1);
  };

  return (
    <ModalImage
      centered
      closable
      footer={null}
      visible={visible}
      onCancel={onClose}
      style={{
        position: 'unset',
      }}
      destroyOnClose
      transitionName=""
      maskTransitionName=""
      closeIcon={
        <CloseIconWrapper onClick={onClose}>
          <Iconmoon className="icon-compose_close" color={color.light} />
        </CloseIconWrapper>
      }
      maskStyle={{
        backgroundColor: 'rgba(18,18,18,0.7)',
      }}
      maskClosable
    >
      {hasPrevButton && <SliderButton type="prev" onClick={handlePrev} />}
      {images.map((image, i) => (
        <ImageItem visible={i === active} alt="stream image" src={image} />
      ))}
      {hasNextButton && <SliderButton type="next" onClick={handleNext} />}
    </ModalImage>
  );
}

export default ModalImageSlider;
